<template>
    <div class="tableWrapper">        
        <table ref="contentTable">
            <tr class="tHead">
                <th>Amount</th>
                <th :style="{ width: '200px' }">Task</th>
                <th :style="{ width: '250px' }">Description</th>
                <th>Cost (USD)</th>
                <th>Sub total (USD)</th>
            </tr>

            <tr v-for="(task, key) in breakdown" :key="key" >
                <td>{{ task.amount }}</td>
                <td >{{ task.task }}</td>
                <td>{{ task.desc }}</td>
                <td>{{ task.price }}</td>
                <td>{{ task.amount * task.price }}</td>
            </tr>
            
            <tr class="trInsert" v-if="!validating && showAddButton">
                <td>
                    <input type="number" placeholder="Amount..." ref="amount">
                </td>
                <td>
                    <select @change="taskSelected($event)" ref="sltTask">
                        <option value="" disabled selected ref="naTask">Select a task</option>
                        <option v-for="(task, key) in availableTasks" :key="key" >{{ task.task }}</option>
                    </select>
                </td>
                <td>
                    {{ selectedTask.desc || '-' }}
                </td>
                <td>
                    {{ selectedTask.price || '-' }}
                </td>
                <td>
                    <div class="customBtn" @click="insert()" :style="{ width: '63px', padding: '5px', margin: '0 auto' }">
                        <i v-if="!loadingTasks" class="icofont-plus-circle"></i>
                        <p v-if="!loadingTasks">Add</p>

                        <div class="spinerParent" v-if="loadingTasks">
                            <img src="../assets/spin.png" />
                        </div>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="trTotal"></td>
                <td class="trTotal"></td>
                <td class="trTotal"></td>
                <td class="trTotal">Total:</td>
                <td class="trTotal">{{ total }}</td>
            </tr>
        </table>
    </div>
</template>

<style scoped lang="scss">
    .tableWrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 15px 0 0 0;
    }

    table {
        border-collapse: collapse;
    }

    tr {
      font-size: 12px;
      td {
        padding: 12px 0;
        min-width: 90px;
      }
    }
    .tHead {
        background-color: #000;
        height: 35px;
        color: #fff;
        font-size: 13px;
    }

    .trTotal {
        font-weight: bold;
        font-size: 16px;
        border-top: 1px solid #b0b0b0;
    }

    .customBtn {
        display: flex;
        align-items: center;
        margin: 0 10px;
        padding: 7px 10px;
        border-radius: 3px;
        cursor: pointer;
        transition: background-color .5s;
        background-color: #222;
        color: #fff;

        p {
            font-size: 14.5px;
            cursor: pointer;
        }

        i {
            font-size: 23px;
            margin: 0 6px 0 0;
        }

        .spinerParent img {
            height: 24px;
            width: 24px;
        }
    }
    .trInsert {
        td:nth-child(1) {
            input {
                width: 65px;
                padding: 3px 5px;
                font-size: 13px;
                color: #000;
                background-color: transparent;
                border: none;
                outline: none;
                text-align: center;
            }
        }

        td:nth-child(2) {
            select {
                width: 150px;
                padding: 3px 5px;
                font-size: 13px;
                color: #000;
                border: none;
                outline: none;
                background-color: transparent;
            }
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    input[type=number] {
        -moz-appearance: textfield;
    }

</style>

<script>
    import { EventBus } from "../mixins/eventBus.js";
    import Request from "../mixins/axiosRequest.js";

    export default {
        data() {
            return {
                breakdown: [],
                total: 0,
                showAddButton: true,
                validating: false,
                selectedTask: {},
                availableTasks: [],
                loadingTasks: true
            }
        },
        props: {
            Tasks: Array
        },
        methods: {
            insert (task) {
                if(task) {
                    return this.breakdown.push({
                        amount: task.amount,
                        task: task.task,
                        desc: task.desc,
                        price: task.price
                    }); 
                }

                let hasError = false;
                let amount = this.$refs.amount.value;
                if (isNaN(amount) || amount <= 0) {
                    this.$refs.amount.style.backgroundColor = '#ff000075';
                    setTimeout(() => this.$refs.amount.style.backgroundColor = 'transparent' ,5000);
                    hasError = true
                }

                if (!this.selectedTask.task) {
                    this.$refs.sltTask.style.backgroundColor = '#ff000075';
                    setTimeout(() => this.$refs.sltTask.style.backgroundColor = 'transparent' ,5000);
                    hasError = true
                }

                if(hasError) return;

                let newTask = {
                    amount: amount,
                    task: this.selectedTask.task,
                    desc: this.selectedTask.desc,
                    price: this.selectedTask.price
                }
                this.breakdown.push(newTask);

                EventBus.$emit("tableTask", newTask);
                this.total += (amount * this.selectedTask.price);
                this.selectedTask = {};
                this.$refs.amount.value = null;
                this.$refs.naTask.selected = true;
                this.showAddButton = this.maxTableHeight();
            },
            maxTableHeight () {
                const contentTable = this.$refs.contentTable;
                return contentTable.offsetHeight >= 520 ? false : true;
            },
            taskSelected(event) {
                let selected = this.availableTasks.filter(tsk => tsk.task == event.target.value);
                if(selected.length) this.selectedTask = selected[0];
            },
            async loadTasks() {
                let data = await Request.axiosGet("/api/tasks", this.client);
                if(data.status) {
                    this.availableTasks = data.data;
                }
                this.loadingTasks = false;
            }
        },
        mounted() {
            if(this.$route.params.invoice) {
                this.validating = true;
            }
            
            this.loadTasks();

            EventBus.$on("stopValidation", () => {
                this.breakdown = [];
                this.validating = false;
            });

            EventBus.$on("invalidTask", () => {
                this.$refs.sltTask.style.backgroundColor = '#ff000075';
                this.$refs.amount.style.backgroundColor = '#ff000075';

                setTimeout(() => {
                    this.$refs.sltTask.style.backgroundColor = 'transparent';
                    this.$refs.amount.style.backgroundColor = 'transparent';
                }, 5000);
            });
        },
        watch: {
            Tasks: {
                handler(nw) {
                    if(this.validating) {
                        nw.forEach(element => {
                            this.total += (element.amount * element.price);
                            this.insert(element);
                        });
                    }
                },
                immediate: true
            }
        }
    }
</script>